import { put, call } from 'redux-saga/effects';
import { clientQuery } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';
// Actions
import {
  reportsMainGenerateReportProgress,
  reportsMainGenerateReportUpdate
} from 'Redux/actions';

import {
  getTimeZone,
  getCategoryFilter,
  handleAsyncReport,
  baseReportConditions,
  generateReportInstance,
  isJsonFormat
} from 'Modules/reports/views/main/components/reportsTab/helper';

function* getNonReportingReport(report, page, rowsPerPage, sortField, sortOrder, requestFlag) {
  const { timeZone , sendByEmail, emailsTo, name, timeframeName, categoryName, delayed, dataResultPath } = report;
  const { filterType, filterArray, startRange, endRange, unitsSelected, accumulateData = true, dates } = report.filters;

  const baseConditionsQuery = baseReportConditions({ 
    report,
    name,
    dataResultPath,
    timeZone,
    delayed,
    unitsSelected,
    timeframeName,
    filterType,
    filterArray,
    categoryName,
    startRange,
    endRange,
    dates
  })
  try {
    let payload = {
      conditions: {
        ...baseConditionsQuery,
        sortField: {
          field: sortField || "deviceId",
          order: sortOrder === 'desc' ? 'DESC' : 'ASC'
        }
      },
      limit: rowsPerPage,
      offset: page
    };
    
    payload = {
        ...payload,
        limit: (!isJsonFormat(report?.exportType, dataResultPath) || !dataResultPath)? 5000 : rowsPerPage,
        offset: isJsonFormat(report?.exportType, dataResultPath)? page : 1,
        conditions: {
          ...payload.conditions,
          exportOptions: {
            sendByEmail,
            emailsTo,
            format: {
              fileFormat: report?.exportType || "json",
              formatOptions: "{\"addPagination\": \"true\", \"addLogo\": \"true\", \"addLine\": \"true\"}",
              durationFormat: report?.durationFormat
          },
            culture: report.lang,
            timeZone: getTimeZone(timeZone),
            folderName: "px-customer-reports",
            filePrefixName: "nonReportingReport",
            columns: [
              {
                "column": "deviceLabel",
                "header": "Unit"
              },
              {
                "column": "tagLabelVal",
                "header": "Tag"
              },
              {
                "column": "unitTime",
                "header": "Last Reported Date/Time" 
              },
              {
                "column": "address",
                "header": "Last Reported Address"
              }
            ]
          }
        }
    }

    let data = yield call(
      clientQuery,
      `query getNonReportingReport ($conditions: ReportConditionsInput, $limit: Int, $offset: Int) {
        Report: getNonReportingReport (conditions: $conditions, limit: $limit, offset: $offset) {
          ${ generateReportInstance(report.export, dataResultPath, report.exportFromTable)?
            `reportInstanceId`
          :`
            items {
              recordInfo {
                entityId
                entityLabel
                tagId
                tagLabel
                startDate
                endDate
                recordType
                groupLabel
                groupIndex
                groupTotal
                groupTagColor
              }
              recordDetail {
                deviceId
                unitTime
                eventName
                landmarkId
                landmarkName
                tagLabelVal
                deviceLabel
                address
                noData
                installed
                noRecentData
              }
            }
            total
            limit
            offset
            category
        `}
        }
        
      }`,
      payload ,
      endpoints.GRAPHQL_PX_REPORTING,
    );
    yield handleAsyncReport(report, data, accumulateData);

  } catch (exc) {
    ExceptionManager(exc, 'reports/nonReportingReport', 'getNonReportingReport');
    report.loading = false
    yield put(reportsMainGenerateReportProgress(report))
    if (!requestFlag) {
      let flag = true
      yield put(reportsMainGenerateReportUpdate(report, page, rowsPerPage, sortField, sortOrder, flag))
    } else {
      report.loading = false
      yield put(reportsMainGenerateReportProgress(report))
    }
  }
}


export default getNonReportingReport;
